import { render, staticRenderFns } from "./Play-Audio.vue?vue&type=template&id=27fa09d1&"
import script from "./Play-Audio.vue?vue&type=script&lang=js&"
export * from "./Play-Audio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports